function getPlausible() {
  if (typeof window !== 'undefined' && 'plausible' in window) {
    return (window as Record<string, unknown>).plausible as
      | ((event: string, options?: { props: Record<string, string | number> }) => void)
      | undefined;
  }
  return undefined;
}

export function track(event: string, props?: Record<string, string | number>) {
  const plausible = getPlausible();
  if (plausible) {
    if (props) {
      plausible(event, { props });
    } else {
      plausible(event);
    }
  }
}
